import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const NoticeComponent = React.lazy(() => import("../Components/RootComponents/NoticeComponent"));
const NoticePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <NoticeComponent />
      </Suspense>
    </Fragment>
  );
};

export default NoticePage;
